import React from 'react';
import DrawerLearn from './DrawerLearn';

function FooterLearn({ drawer, action, type }) {
    return <DrawerLearn drawer={drawer} action={action} type={type} />;
}

export default FooterLearn;
